/**
 * Frontend entry — global styles, block styles and progressive interactions.
 */
import './styles/app.css';
import './styles/content.css';
import './styles/article-media.css';
import './styles/poster.css';
import './blocks/hero/style.css';
import './styles/spotlight.css';
import './blocks/spotlight/style.css';
import './blocks/spotlight-archive/style.css';
import './blocks/spotlight-hero/style.css';
import './blocks/spotlight-more/style.css';
import './blocks/events/style.css';
import './blocks/membership/style.css';
import './blocks/community/style.css';
import './blocks/articles/style.css';
import './blocks/event-poster/style.css';
import './blocks/event-header/style.css';
import './blocks/event-notes/style.css';
import './blocks/event-banner/style.css';
import './blocks/event-bar/style.css';
import './blocks/dancegroup-list/style.css';
import './blocks/dancegroup-profile/style.css';
import './blocks/faq/style.css';
import './blocks/what-we-do/style.css';
import './blocks/team/style.css';
import './blocks/contact/style.css';
import './blocks/event-calendar/style.css';
import './blocks/event-submit/style.css';
import './blocks/fan-guide/style.css';
import './blocks/whatsapp-groups/style.css';
import './blocks/marquee/style.css';
import './styles/profile.css';

import { initReveal } from './js/reveal.js';
import { initCountdowns } from './js/countdown.js';
import { initMenu } from './js/menu.js';
import { initHero } from './blocks/hero/view.js';
import { initCalendar } from './blocks/event-calendar/view.js';
import { initSpotlight } from './js/spotlight/index.js';
import { initMarquee } from './blocks/marquee/view.js';
import { initEventFilters } from './js/event-filters.js';
import { initEventClamp } from './js/event-clamp.js';
import { initEventBar } from './js/event-bar.js';

function boot() {
	initHero();
	initReveal();
	initCountdowns();
	initMenu();
	initCalendar();
	initSpotlight();
	initMarquee();
	initEventClamp();
	initEventFilters();
	initEventBar();
}

if (document.readyState !== 'loading') {
	boot();
} else {
	document.addEventListener('DOMContentLoaded', boot);
}
